import { render } from "./EventCard.vue?vue&type=template&id=6e66f5b5"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=6e66f5b5&lang=css"
script.render = render

export default script